import { IPagination, IProductV1 } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	filter: { id?: string } & IPagination
	include?: { audits?: boolean }
}

interface ResponseDataShape {
	success: boolean
	data: IProductV1[]
}

export async function productListApi(payload: RequestDataShape, token?: null | string) {
	const endpoint = "/product/list/v1"
	const requester = new ApiRequester<RequestDataShape, ResponseDataShape>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response.data
}
